export const formatTicketCountBadge = (count: number): string => {
  if (count > 9999) {
    return "9999+";
  }

  return String(count);
};
